import {
  LOGIN_ACCOUNT,
  // LOGIN_ASYNC_ACCOUNT,
  ERROR_LOGIN,
  CLOSE_SESSION,
  CHANGE_PASSWORD,
} from './../Action-type/Index';

import { closeLoader } from './Modal';


import { api_base, LOCAL_STORAGE } from './../constants/services/api';

// var api_base = 'http://apiareademo.us-west-1.elasticbeanstalk.com';

export function login(session) {
  localStorage.setItem(LOCAL_STORAGE, JSON.stringify(session));
  return {
    type: LOGIN_ACCOUNT,
    payload: {
      session
    }
  }
}

export function errorLogin() {
  return {
    type: ERROR_LOGIN,
  }
}

export function loginAsync(user, password) {
  return async (dispatch) => {
    try {
      const respFetch = await fetch(`${api_base}/api/v1/users/login`, {
        method: "POST",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          user,
          password
        })
      })
      if (respFetch.status !== 200) {
        dispatch(closeLoader())
        dispatch(errorLogin());
      } else {
        const respJson = await respFetch.json()

        dispatch(closeLoader())
        if (respJson.access === "Fail") {
          dispatch(errorLogin())
        } else {
          dispatch(login(respJson));
        }
      }
    } catch (error) {
      console.log('err', (error))
      // dispatch(closeLoader())
      // dispatch(errorLogin());

    }
  }
}

export function closeSession() {
  localStorage.removeItem(LOCAL_STORAGE);
  return {
    type: CLOSE_SESSION,
  }
}

export function changePass(oldPass, newPass) {
  return {
    type: CHANGE_PASSWORD,
    payload: {
      oldPass,
      newPass
    }
  }
}